import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertSizePipe } from './convert-size.pipe';

@NgModule({
  declarations: [ConvertSizePipe],
  exports: [ConvertSizePipe],
  imports: [CommonModule],
})
export class ConvertSizeModule {}
